import { useSendData } from 'api/useApi';

export const useSignatureApi = () => {
  const { response, isSending, callApi, error } = useSendData();

  return { signatureResponse: response, signatureError: error, sendingSignature: isSending, callSignatureApi: callApi };
};
